// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import useJwt from '@src/auth/jwt/useJwt'
const config = useJwt.jwtConfig
const companyID = JSON.parse(localStorage.getItem('companyID'))
 
const headers = {
  token: JSON.parse(localStorage.getItem(config.storageTokenKeyName)),
  userID: JSON.parse(localStorage.getItem('userID'))
}

export const GetDefaultPaymentModel = createAsyncThunk('appDriverType/GetDefaultPaymentModel', async () => {
  
  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDefaultPaymentModelList', { headers })
  
  return response.data
})

export const getAllData = createAsyncThunk('appDriverType/GetTableSummary', async () => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummary', GetDriver, { mode: 'cors' })

  return response.data
})

export const getData = createAsyncThunk('appDriverType/getData', async (params) => {


  const response = await axios.post('https://api.zasway.com:8443/DriverType/GetTableSummary', params, { mode: 'cors' })

  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const getDriverTypeEditData = createAsyncThunk('appDriverType/getDriverTypeEditData', async (params) => {


  const response = await axios.post('https://api.zasway.com:8443/DriverType/GetTableSummary', params, { mode: 'cors' })
  return { data: response.data.data }
})

export const resetDriverTypeEditData = createAsyncThunk('appDriverType/resetDriverTypeEditData', async () => {

  return { data: [] }
})

export const addDriverType = createAsyncThunk('appDriverType/Create', async (Driver, { dispatch }) => {

  const response = await axios.post('https://api.zasway.com:8443/DriverType/Create', Driver, { mode: 'cors' })

  await dispatch(getData({
    companyID,
    userID: 0,
    id: 0,
    page: 0,
    perPage: 10
  }))
  return response
})

export const EditDriverType = createAsyncThunk('appDriverType/Update', async (Driver) => {
  const response = await axios.post('https://api.zasway.com:8443/DriverType/Update', Driver, { mode: 'cors' })
  return response
})

export const deleteDriverType = createAsyncThunk('appDriverType/Delete', async (id, { dispatch, getState }) => {

  const response = await axios.post('https://api.zasway.com:8443/DriverType/Delete', id, { mode: 'cors' })

  await dispatch(getData(getState().driverType.params))

  return response
})

export const appDriverTypeSlice = createSlice({
  name: 'appDriverType',
  initialState: {
    driverTypedata: [],
    driverTypeEditdata: [],
    driverTypetotal: 1,
    driverTypeparams: {},
    driverTypeallData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        state.driverTypedata = action.payload.data
        state.driverTypeallData = action.payload.allData
        state.driverTypetotal = action.payload.totalPages
        state.driverTypeparams = action.payload.params
      })
      .addCase(getDriverTypeEditData.fulfilled, (state, action) => {
        state.driverTypeEditdata = action.payload.data
      })
      .addCase(resetDriverTypeEditData.fulfilled, (state, action) => {

        state.driverTypeEditdata = action.payload.data
      })

  }
})

export default appDriverTypeSlice.reducer
